import "../../assets/Common.scss";
import "../../assets/fonts/font.css";
import React, { useEffect, useRef } from "react";

import { chipsAppCode } from "../../js/chips-common.js";
import chipsWebApi from "../../js/chips-web-api";

export default function NaverLoginCallBack(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const endPoint = window.location.origin;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // NAVER
  const naverClientId = "EbppPeiqogNH0vZk938b";
  const naverRedirectUri = `${endPoint}/user/login`; //Redirect URI
  const naverSdkUrl =
    "https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js";

  const initiailized = useRef(false);

  function goToLogin() {
    window.location.href = `${endPoint}/user/login`;
  }

  useEffect(() => {
    if (!initiailized.current) {
      initiailized.current = true;

      const error = urlParams.get("error");
      const errorDescription = urlParams.get("error_description");
      if (error) {
        alert(
          `${error}\n${errorDescription}` || "네이버 로그인에 실패하였습니다.",
        );
        return;
      }

      // Naver Login SDK
      new Promise((onload, reject) => {
        const src = naverSdkUrl;
        const script = document.createElement("script");
        const onError = (evt) => {
          reject(URIError(`스크립트 로딩 실패 ${evt.target.src}`));
          goToLogin();
        };

        Object.assign(script, {
          type: "text/javascript",
          onload,
          onError,
          src,
        });
        document.head.appendChild(script);
      }).then(() => {
        // eslint-disable-next-line no-undef
        let naverLogin = new naver.LoginWithNaverId({
          clientId: naverClientId,
          callbackUrl: naverRedirectUri,
          isPopup: false,
          callbackHandle: true,
          loginButton: {
            color: "green",
            type: 3,
            height: 60,
          },
        });
        naverLogin.init();
        // eslint-disable-next-line no-undef
        const accessToken = naverLogin.accessToken.accessToken;
        getChipsToken(accessToken, accessToken);
      });
    }
  }, []);

  function getChipsToken(accessToken, refreshToken) {
    chipsWebApi.request({
      method: "post",
      url: `${domain}/api/v2/sign/socials`,
      headers: {
        "x-nbt-app-code": chipsAppCode,
        "x-nbt-social-provider": "naver",
        "x-nbt-social-access-token": accessToken,
        "x-nbt-social-refresh-token": refreshToken,
      },
      data: {},
      then: (response) => {
        const accessToken = response.headers["x-nbt-access-token"];
        const refreshToken = response.headers["x-nbt-refresh-token"];
        window.location.href = `${endPoint}/user/withdraw?accessToken=${accessToken}&refreshToken=${refreshToken}`;
      },
      error: (error, _) => {
        goToLogin();
      },
    });
  }

  return (
    <div>
      <div id="naverIdLogin" style={{ display: "none" }}></div>
    </div>
  );
}
